import React from 'react';
import { routes } from 'constants/config';
import { Card, ButtonGroup, Button } from 'components/ui';

const AskForFeedback = ({ scenarioId, attempt, canRequestFeedback }) => {
  if (!canRequestFeedback && !attempt.hasFeedback) {
    return null;
  }

  return (
    <Card.Content padding="medium" className="bg-gray-lightest bt-gray-lighter">
      {canRequestFeedback && (
        <div className="d-f fd-c mb-16">
          <span className="fw-b fz-14">
            {t(
              'practice.on_demand_practice.previous_attempts.feedback.ask_for_feedback_title',
            )}
          </span>
          <span>
            {t(
              'practice.on_demand_practice.previous_attempts.feedback.ask_for_feedback_instructions',
            )}
          </span>
        </div>
      )}
      <ButtonGroup className="d-f jc-sb fw-w">
        {canRequestFeedback && (
          <Button
            customColor
            className="mb-8"
            url={routes.ON_DEMAND_PRACTICE.LEARNING.ATTEMPTS.REQUEST_FEEDBACK(
              scenarioId,
              attempt.id,
            )}
          >
            {t(
              'practice.on_demand_practice.previous_attempts.feedback.ask_for_feedback_button',
            )}
          </Button>
        )}
        {attempt.hasFeedback && (
          <Button
            className="mb-8"
            url={routes.ON_DEMAND_PRACTICE.LEARNING.ATTEMPTS.FEEDBACK(
              scenarioId,
              attempt.id,
            )}
          >
            {t(
              'practice.on_demand_practice.previous_attempts.feedback.view_feedback_button',
            )}
          </Button>
        )}
      </ButtonGroup>
    </Card.Content>
  );
};

export default AskForFeedback;
